module.exports = __webpack_public_path__ + "static/img/quan_jiang_2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/quan_jiang_2.jpg
// module id = qFrY
// module chunks = 0